import get from "lodash/get";
import { Sort } from "@/common/types/Sort";

export const compareSort = <T>(a: T, b: T, sorts: Sort[]): number => {
  if (sorts.length === 0) {
    return 0;
  }

  const sort = sorts[0];
  const aValue = get(a, sort.key);
  const bValue = get(b, sort.key);

  if ((aValue === null || aValue === undefined) && (bValue === null || bValue === undefined)) {
    return compareSort(a, b, sorts.slice(1));
  }
  if (aValue === null || aValue === undefined) {
    return 1;
  }
  if (bValue === null || bValue === undefined) {
    return -1;
  }
  if (aValue !== bValue) {
    if (typeof aValue === "string") {
      return stringCompare(aValue, bValue) * (sort.isDesc ? -1 : 1);
    }
    return (aValue < bValue ? -1 : 1) * (sort.isDesc ? -1 : 1);
  }
  return compareSort(a, b, sorts.slice(1));
};

const stringCompare = (a: string, b: string): number => {
  const checkWeight = (str: string) => {
    if (/^[A-Za-z]/.test(str)) {
      return 0;
    }
    if (/^[0-9]/.test(str)) {
      return 1;
    }
    return 2;
  };

  if (checkWeight(a) !== checkWeight(b)) {
    return checkWeight(a) - checkWeight(b);
  }

  return a.localeCompare(b);
};
